import { Card, Col, Image, Row, Space, Tag, Typography } from "antd";
import dayjs from "dayjs";
import { useSettings } from "context/providers/settings";
const Signature = ({ data }) => {
  const { mode } = useSettings();

  return (
    <Card
      title="Podpis klienta"
      extra={data?.id ? <Tag color="green">Podpisano</Tag> : null}
      style={{ marginBottom: 24 }}
    >
      <Space>
        {data?.image_url ? (
          <div
            style={{
              padding: "8px",
              borderRadius: 8,
              border: `1px solid ${mode === "dark" ? "#424242" : "#d9d9d9"}`,
            }}
          >
            <Image
              width={100}
              src={data?.image_url}
              placeholder={
                <Image preview={false} src={data?.image_thumb_url} />
              }
            />
          </div>
        ) : (
          <Typography.Text>Brak podpisu klienta</Typography.Text>
        )}
      </Space>
      {data?.created_at && (
        <Row gutter={24} className="m-t-20">
          <Col xs={24}>
            <Typography.Text type="secondary">
              Data podpisu: {dayjs(data.created_at).format("DD-MM-YYYY HH:mm")}
            </Typography.Text>
          </Col>
        </Row>
      )}
    </Card>
  );
};
export default Signature;